









































import { Component, Prop, Vue, Model } from 'vue-property-decorator';
import { PaneStatus } from '../components/PaneSet';
import msplit from '../lib';

Vue.use(msplit);

@Component
export default class MSplitTest extends Vue {
  private s1 = [true];
  private s2 = [true];
  private s3 = [true];
  private s31 = [true];
  private s32 = [true];
  private s4 = [true];
  private s41 = [true];
  private s42 = [true];
  private maxPane = '';
}
